export default class TagueamentoService {
  eventoMarketingCadastro() {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "generate_lead", // Nome do evento
      });
    } catch (ex) {
      console.log("Tivemos problemas com o Google", ex);
    }
  }

  eventoMarketingCotacao(cotacao) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "simulate_shipping", // Nome do evento
        CEP_origin_city: cotacao.cepOrigem, // CEP da cidade de origem
        CEP_destination_city: cotacao.cepDestino, // CEP da cidade de destino
      });
    } catch (ex) {
      console.log("Tivemos problemas com o Google", ex);
    }
  }

  eventoMarketingInserirSaldo(tipo, valor) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "confirm_value", // Nome do evento
        payment_type: tipo, // Informear meio de pagamento: crédito ou boleto
        value: valor, // Informar o valor de crédito inserido pelo usuário
      });
    } catch (ex) {
      console.log("Tivemos problemas com o Google", ex);
    }
  }

  eventoMarketingCreditoInserido() {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "credit_inserted", // Nome do evento
      });
    } catch (ex) {
      console.log("Tivemos problemas com o Google");
    }
  }

  eventoMarketingCotacaoLogado() {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "calculate_shipping", // Nome do evento
      });
    } catch (ex) {
      console.log("Tivemos problemas com o Google", ex);
    }
  }

  eventoMarketingItemSelecionado(cotacao) {
    try {
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: "select_item",
        deadline: cotacao.prazoDeEntrega.tempoMaximo, // Inserir informação de prazo de entrega
        ecommerce: {
          items: [
            {
              item_id: cotacao.uuid, // Inserir código do frete
              price: cotacao.valorFrete, // Inserir valor do frete
              item_brand: cotacao.transportadora.nomeTransportadora, // Inserir empresa responsável pelo frete
              item_category: cotacao.produto.nomeProduto, // Inserir a modalidade do frete
              quantity: "1", // Inserir a quantidade selecionada para o item
            },
          ],
        },
      });
    } catch (ex) {
      console.log("Tivemos problemas com o Google", ex);
    }
  }

  eventoMarketingAdicionarAoCarrinho(cotacao, remetente, destinatario) {
    const hostname = window.location.hostname;
    let version = "unknown";

    if (hostname.startsWith("www2.")) {
      version = "b";
    } else if (hostname.startsWith("www.")) {
      version = "a";
    }
    try {
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: "add_to_cart",
        deadline: cotacao.prazoDeEntrega.tempoMaximo, // Inserir informação de prazo de entrega
        ecommerce: {
          value: cotacao.valorFrete, // Inserir valor do frete
          currency: "BRL", // Sempre trazer BRL
          ab_test: version,
          items: [
            {
              item_id: cotacao.uuid, // Inserir código do frete
              item_name: cotacao.transportadora.nomeTransportadora, // Inserir empresa responsável pelo frete
              index: 0,
              item_brand: cotacao.transportadora.nomeTransportadora, // Inserir empresa responsável pelo frete

              item_category: cotacao.produto.nomeProduto, // Inserir a modalidade do frete
              price: cotacao.valorFrete, // Inserir valor do frete
              item_category2: remetente.endereco.cidade, //cidade informada de origem do frete
              item_category3: remetente.endereco.estado, //estado informado de origem
              item_category4: destinatario.endereco.cidade, //cidade informada de destino do frete
              item_category5: destinatario.endereco.estado, //estado informado de destino do frete
            },
          ],
        },
      });
    } catch (ex) {
      console.log("Tivemos problemas com o Google", ex);
    }
  }

  eventoMarketingCheckoutCarrinho(fretesCarinho) {
    if (fretesCarinho) {
      try {
        const itens = [];
        for (let frete of fretesCarinho) {
          itens.push({
            item_id: frete.uuid, // Inserir código do frete
            price: frete.valorFrete, // Inserir valor do frete
            item_brand: frete.transportadora.nomeTransportadora, // Inserir empresa responsável pelo frete
            item_category: frete.produto.nomeProduto, // Inserir a modalidade do frete
            quantity: "1", // Inserir a quantidade selecionada para o item
            origin_city: frete?.remetente?.endereco?.cidade, // Cidade de Origem
            CEP_origin_city: frete.cotacao.cepOrigem, // CEP cidade de Origem
            destination_city: frete?.destinatario?.endereco?.cidade, // Cidade de Destino
            CEP_destination_city: frete.cotacao.cepDestino, // CEP cidade de destino
            deadline: frete.cotacao.prazoDeEntrega.tempoMaximo, // Inserir prazo de entrega
          });
        }

        window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        window.dataLayer.push({
          event: "begin_checkout",
          ecommerce: {
            items: itens,
          },
        });
      } catch (ex) {
        console.log("Tivemos problemas com o Google", ex);
      }
    }
  }

  eventoMarketingConfirmacaoCompraPagamento(fretesCarinho, somaValorTotalFretes, uuidCarinho) {
    try {
      const itens = [];
      for (let frete of fretesCarinho) {
        itens.push({
          item_id: frete.uuid, // Inserir código do frete
          price: frete.valorFrete, // Inserir valor do frete
          item_brand: frete.transportadora.nomeTransportadora, // Inserir empresa responsável pelo frete
          item_category: frete.produto.nomeProduto, // Inserir a modalidade do frete
          quantity: "1", // Inserir a quantidade selecionada para o item
        });
      }

      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: "purchase",
        ecommerce: {
          currency: "BR",
          value: somaValorTotalFretes, // Valor final da compra
          transaction_id: uuidCarinho, // Informar o ID da transação
          items: itens,
        },
      });
    } catch (ex) {
      console.log("Tivemos problemas com o Google", ex);
    }
  }

  eventoMarketingFinalizarPagamento(fretesCarinho) {
    try {
      const itens = [];
      for (let frete of fretesCarinho) {
        itens.push({
          item_id: frete.uuid, // Inserir código do frete
          price: frete.valorFrete, // Inserir valor do frete
          item_brand: frete.transportadora.nomeTransportadora, // Inserir empresa responsável pelo frete
          item_category: frete.produto.nomeProduto, // Inserir a modalidade do frete
          quantity: "1", // Inserir a quantidade selecionada para o item
          deadline: frete.cotacao.prazoDeEntrega.tempoMaximo, // Inserir prazo de entrega
        });
      }

      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: "add_shipping_info",
        ecommerce: {
          shipping_tier: "FlexFrete",
          items: itens,
        },
      });
    } catch (ex) {
      console.log("Tivemos problemas com o Google", ex);
    }
  }

  eventoMarketingCheckoutTransparente(
    fretesCarinho,
    tipoPagamento,
    valor,
    transactionId,
    uuidCarinho
  ) {
    console.info("TAGUEAMENTO CHAMADO");
    try {
      const itens = [];
      if (fretesCarinho) {
        let index = 0;
        for (let frete of fretesCarinho) {
          itens.push({
            item_id: frete.uuid, // Inserir código do frete
            item_name: frete.transportadora.nomeTransportadora, // trazer o nome da transportadora da etiqueta
            index: index++,
            item_brand: frete.transportadora.nomeTransportadora, // Inserir empresa responsável pelo frete
            item_category: frete.produto.nomeProduto, // Inserir a modalidade do frete
            price: frete.valorFrete, // Inserir valor do frete
            quantity: 1, // Inserir a quantidade selecionada para o item
            item_category2: frete?.remetente?.endereco?.cidade, //cidade informada de origem do frete
            item_category3: frete?.remetente?.endereco?.estado, //estado informado de origem
            item_category4: frete?.destinatario?.endereco?.cidade, //cidade informada de destino do frete
            CEP_destination_city: frete?.destinatario?.endereco?.estado, //estado informado de destino do frete
          });
        }
      }
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: "purchase",
        ecommerce: {
          transaction_id: uuidCarinho, // Trazer o código da transação de compra
          value: valor, // Soma de (price * quantity) para todos os itens da compra (valor total da compra).
          currency: "BRL", // Sempre trazer BRL
          payment_type: tipoPagamento, // Tipo do pagamento da Compra: "cartao_credito", "pix", "carteira_flex", "cartao_credito+pix", "carteira_flex+cartao_credito", "carteira_flex+pix"
          items: itens,
        },
      });
    } catch (ex) {
      console.log("Tivemos problemas com o Google", ex);
    }
  }
}
